import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { PapiGallection } from '@wix/da-papi-types';
import { BiData, ManageInStudioClickBiEvent } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import StudioGalleryIcon from '@wix/da-ds/pkg/Icons/16x16/StudioGallery';

export interface Props {
  className?: string;
  gallection?: PapiGallection;
}

const ManageInStudioButton: FC<Props> = ({ className, gallection }) => {
  const { t } = useTranslation();

  return (
    <TextButton
      variant="edit-purple"
      size="medium"
      href={Url.studioGallery(gallection?.folderId)}
      className={className}
      data-role="edit-control"
      icon={StudioGalleryIcon}
      biData={BiData<ManageInStudioClickBiEvent>({
        evid: 15,
        link_name: t('common.manageInStudio'),
        link_url: Url.studioGallery(gallection?.folderId),
        sectionname: 'gallection',
      })}
    >
      {t('common.manageInStudio')}
    </TextButton>
  );
};

ManageInStudioButton.displayName = 'ManageInStudioButton';

export default ManageInStudioButton;
